import React, { Fragment, useRef, useEffect } from "react";
import "./style.sass";
import useHandler from "./handler";
import assets from "../../assets";
import { ROUTE_LOGIN } from "../../route";
import { ROUTE_DASHBOARD } from "../../route/studentRoute";
import { ROUTE_DASHBOARD as TnpscRoute } from "../../route/tnpscRoute";
import { ROUTE_DASHBOARD as NeetJ2ERoute } from "../../route/neetJteRoute";
import {
  ROUTE_SIGN_UP,
  ROUTE_STUDENT_MANAGEMENT,
  ROUTE_DASHBOARD as ROUTE_USER_DASHBOARD,
} from "../../route";

const TAB_LIST = [
  { id: 1, label: "Account Details" },
  { id: 2, label: "User Details" },
  { id: 3, label: "Address Details" },
  { id: 4, label: "Educational Info" },
  { id: 5, label: "Location" },
];

export const SignUp = ({ noWrapper = false }) => {
  const {
    SCHOOL_LEVELS,
    COLLEGE_LEVELS,
    boards,
    genders,
    focuss,
    gradeClass,
    mediumInstruction,
    eductationLevel,
    data,
    error,
    activeStep,
    role,
    signletonBoard,
    examType,
    setActiveStep,
    onChangeValue,
    setBoards,
    setGenders,
    setFocuss,
    setGradeClass,
    setMediumInstrction,
    setEducationLevel,
    onSubmit,
    onValidate,
    onFocusChange,
    navigate,
    isLoading,
  } = useHandler();
  const {
    email,
    name,
    phone,
    city,
    state,
    country,
    level,
    grade,
    board,
    institution,
    medium_of_instruction,
    focus,
    age,
    gender,
    section,
  } = data;

  const isSchool = SCHOOL_LEVELS.includes(level);
  const isCollege = COLLEGE_LEVELS.includes(level);
  const isLastStep = activeStep === TAB_LIST.length;

  const renderContent = () => {
    switch (activeStep) {
      case 1:
        return (
          <AccountDetails
            email={email}
            name={name}
            phone={phone}
            onChangeValue={onChangeValue}
            error={error}
          />
        );
      case 2:
        return (
          <UserDetails
            age={age}
            gender={gender}
            genders={genders}
            onChangeValue={onChangeValue}
            error={error}
          />
        );
      case 3:
        return (
          <AddressDetails
            city={city}
            state={state}
            country={country}
            onChangeValue={onChangeValue}
            error={error}
          />
        );
      case 4:
        return (
          <EducationalInfo
            error={error}
            gradeClass={gradeClass}
            grade={grade}
            level={level}
            board={board}
            boards={boards}
            section={section}
            eductationLevel={eductationLevel}
            isSchool={isSchool}
            onChangeValue={onChangeValue}
          />
        );
      case 5:
        return (
          <Location
            institution={institution}
            focus={focus}
            focuss={focuss}
            mediumInstruction={mediumInstruction}
            medium_of_instruction={medium_of_instruction}
            onChangeValue={onChangeValue}
            onFocusChange={onFocusChange}
            error={error}
            isCollege={isCollege}
            board={board}
          />
        );
      default:
        return null;
    }
  };

  const content = (
    <section className="right_side_container">
      <div className="form_header">
        <div className="center_logo_bg">
          <img src={assets.ic_login_graudate_white} alt="grad_icon" />
        </div>
        <h2 className="welcome_header">Sign Up</h2>
        <p className="sub_welcome_text">
          Create your account to start your learning adventure.
        </p>
      </div>
      <section className="tabs_container">
        {TAB_LIST?.map((tab) => {
          const isActive = activeStep === tab.id;
          const isCompleted = activeStep > tab.id;
          return (
            <section
              key={tab.id}
              className={`tab_item ${isActive ? "active" : ""} ${isCompleted ? "completed" : ""}`}
              onClick={() => {
                if (tab.id > activeStep) {
                  let allValid = true;
                  for (let i = activeStep; i < tab.id; i++) {
                    const { isValid } = onValidate(i);
                    if (!isValid) {
                      allValid = false;
                      setActiveStep(i);
                      break;
                    }
                  }
                  if (allValid) setActiveStep(tab.id);
                } else {
                  setActiveStep(tab.id);
                }
              }}
            >
              <span className="tab_number">
                {isCompleted ? "\u2713" : tab.id}
              </span>
            </section>
          );
        })}
      </section>
      <section className="tab_content_wrapper">{renderContent()}</section>
      <button
        disabled={isLoading}
        className="sign_up_btn_wrapper"
        onClick={() => {
          if (isLoading) return;

          const { isValid } = onValidate(activeStep);
          if (!isValid) return;

          if (!isLastStep) {
            setActiveStep((prev) => prev + 1);
          } else {
            onSubmit();
          }
        }}
      >
        <h4>
          {isLoading ? (
            <div className="loader"></div>
          ) : isLastStep ? (
            "Submit"
          ) : (
            "Next"
          )}
        </h4>
      </button>
    </section>
  );

  if (noWrapper) return content;

  return (
    <>
      <section className="main_login_container">
        <section className="login_card_wrapper">
          <section className="left_side_container">
            <div className="branding_overlay">
              <div className="brand_logo_box">
                <img src={assets.ic_login_graudate_white} alt="logo" />
              </div>
              <div className="brand_text_wrapper">
                <h3 className="brand_title">Rovian EduSuite</h3>
                <p className="brand_subtitle">
                  Your AI-powered learning partner.
                </p>
              </div>
            </div>

            <div className="hero_visual_container">
              {/* Background Decorative Circles */}
              <div className="decor_circle circle_muted_yellow"></div>
              <div className="decor_circle circle_light_blue"></div>
              <div className="decor_circle circle_light_red"></div>

              {/* Central Robot */}
              <div className="main_robot_circle">
                <div className="robot_inner_bg">
                  <img src={assets.ic_robot_box} alt="robot" />
                </div>
              </div>

              {/* Floating Square Cards */}
              <div className="floating_card pos_book">
                <img src={assets.ic_book_voilet} alt="book" />
              </div>
              <div className="floating_card pos_pencil">
                <img src={assets.ic_pencil} alt="pencil" />
              </div>
              <div className="floating_card pos_cap">
                <img src={assets.ic_graudate_color} alt="cap" />
              </div>
              <div className="floating_card pos_calc">
                <img src={assets.ic_calculator} alt="calc" />
              </div>

              {/* Colored Accent Circles */}
              <div className="accent_circle pos_bulb">
                <img src={assets.ic_lightbulb_white} alt="bulb" />
              </div>
              <div className="accent_circle pos_star">
                <img src={assets.ic_star} alt="star" />
              </div>
            </div>

            <div className="chat_bubble_container">
              <div className="chat_bubble">
                <div className="chat_icon_bg">
                  <img src={assets.ic_message_white_box} alt="chat" />
                </div>
                <div className="chat_content">
                  <p>
                    Hey there! I'm Rovian, your personal AI copilot for
                    learning. I am here to make you master lessons in both
                    engaging and effortless ways. Ready to start learning?
                  </p>
                </div>
              </div>
            </div>
          </section>
          {content}
        </section>
      </section>
    </>
  );
};

const AccountDetails = ({ email, name, phone, onChangeValue, error }) => {
  const { errEmail, errName, errPhone } = error;

  return (
    <section>
      <h4>Email address</h4>
      <section className="email_input_container has_icon icon_mail email_content">
        <input
          name="email"
          value={email}
          onChange={onChangeValue}
          placeholder="name@domain.com"
        />
      </section>
      {errEmail && <p className="err_text">{errEmail}</p>}

      <h4 className="email_header">Name</h4>
      <section className="email_input_container has_icon icon_user phone_content">
        <input
          name="name"
          value={name}
          onChange={onChangeValue}
          placeholder="Enter your name"
        />
      </section>
      {errName && <p className="err_text">{errName}</p>}
      <h4 className="email_header">Phone Number</h4>
      <section className="email_input_container has_icon icon_phone phone_content">
        <input
          type="number"
          name="phone"
          value={phone}
          onChange={(e) => {
            let value = e.target.value.replace(/\D/g, "");

            // First digit must be 6,7,8,9
            if (value.length > 0 && !["6", "7", "8", "9"].includes(value[0])) {
              return;
            }

            value = value.slice(0, 10);

            onChangeValue({
              target: {
                name: "phone",
                value,
              },
            });
          }}
          placeholder="Enter Your Phone Number"
          maxLength={10}
        />
      </section>
      {errPhone && <p className="err_text">{errPhone}</p>}
    </section>
  );
};

const UserDetails = ({ age, gender, genders, onChangeValue, error }) => {
  return (
    <Fragment>
      <section className="tab_content">
        <h4>Age</h4>
        <input
          type="number"
          name="age"
          value={age}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "").slice(0, 3);
            onChangeValue({
              target: {
                name: "age",
                value,
              },
            });
          }}
          placeholder="Enter Age"
        />
        {error.errAge && <p className="err_text">{error.errAge}</p>}
      </section>
      <section className="user_details_tab_container">
        <h4>Gender</h4>

        <select name="gender" value={gender} onChange={onChangeValue}>
          <option value="" disabled>
            Select Gender
          </option>
          {genders?.map((item, index) => (
            <option key={index} value={item}>
              {item}
            </option>
          ))}
        </select>
      </section>
      {error.errFocus && <p className="err_text">{error.errGender}</p>}
    </Fragment>
  );
};

const AddressDetails = ({ city, state, country, onChangeValue, error }) => {
  const { errCity, errState, errCountry } = error;

  return (
    <section className="tab_content">
      <h4>City</h4>
      <section className="email_input_container">
        <input
          name="city"
          value={city}
          onChange={onChangeValue}
          placeholder="Enter your city"
        />
      </section>
      {errCity && <p className="err_text">{errCity}</p>}
      <h4>State</h4>
      <section className="email_input_container">
        <input
          name="state"
          value={state}
          onChange={onChangeValue}
          placeholder="Enter your State"
        />
      </section>

      {errState && <p className="err_text">{errState}</p>}
      <h4>Country</h4>
      <section className="email_input_container">
        <input
          name="country"
          value={country}
          onChange={onChangeValue}
          placeholder="Enter Your Country"
        />
      </section>

      {errCountry && <p className="err_text">{errCountry}</p>}
    </section>
  );
};

const Location = ({
  institution,
  medium_of_instruction,
  mediumInstruction,
  focus,
  focuss,
  onChangeValue,
  onFocusChange,
  error,
  isCollege,
  board,
}) => {
  const filteredMediumInstructions = mediumInstruction || [];
  const { errInstitution, errMediumOfInstruction, errAreaOffocus } = error;
  const [focusOpen, setFocusOpen] = React.useState(false);
  const wrapperRef = useRef(null);
  const isFocus = focus.includes("Communicative English");

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setFocusOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <section className="tab_content">
      <h4>Institution Name</h4>
      <section className="email_input_container">
        <input
          name="institution"
          value={institution}
          onChange={onChangeValue}
          placeholder="Enter your Institution name"
        />
      </section>
      {errInstitution && <p className="err_text">{errInstitution}</p>}

      <>
        <h4>Focus Area</h4>

        <div className="multiselect_wrapper" ref={wrapperRef}>
          <div
            className="multiselect_trigger"
            onClick={() => setFocusOpen((prev) => !prev)}
          >
            {focus.length === 0 ? (
              <span className="multiselect_placeholder">
                Select Your Area of Focus
              </span>
            ) : (
              <div className="multiselect_tags">
                {focus.map((f) => (
                  <span key={f} className="multiselect_tag">
                    {f}
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        onFocusChange(f);
                      }}
                    >
                      &times;
                    </button>
                  </span>
                ))}
              </div>
            )}

            <span className={`multiselect_arrow ${focusOpen ? "open" : ""}`} />
          </div>

          {focusOpen && (
            <div className="multiselect_dropdown">
              {focuss?.map((item, index) => (
                <label key={index} className="multiselect_option">
                  <input
                    type="checkbox"
                    checked={focus.includes(item)}
                    disabled={
                      focus.includes("Communicative English") &&
                      item !== "Communicative English"
                    }
                    onChange={() => onFocusChange(item)}
                  />
                  {item}
                </label>
              ))}
            </div>
          )}
        </div>

        {errAreaOffocus && <p className="err_text">{errAreaOffocus}</p>}

        {!isFocus && (
          <>
            <h4>Medium of Instruction</h4>
            <select
              name="medium_of_instruction"
              value={medium_of_instruction}
              onChange={onChangeValue}
            >
              <option value="" disabled>
                Select Medium of Instruction
              </option>
              {filteredMediumInstructions?.map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
            </select>
            {errMediumOfInstruction && (
              <p className="err_text">{errMediumOfInstruction}</p>
            )}
          </>
        )}
      </>
    </section>
  );
};

const EducationalInfo = ({
  section,
  error,
  gradeClass,
  grade,
  boards,
  board,
  level,
  eductationLevel,
  isSchool,
  onChangeValue,
}) => {
  const { errLevel, errGradeClass, errBoard, errSection } = error;

  const GRADE_MAP = {
    Primary: ["1", "2", "3", "4", "5"],
    Secondary: ["6", "7", "8", "9", "10"],
    "Higher Secondary": ["11", "12"],
  };
  const filteredGradeClass = GRADE_MAP[level] ?? gradeClass ?? [];

  return (
    <section className="tab_content">
      <label>Educational Level</label>

      <select name="level" value={level} onChange={onChangeValue}>
        <option value="" disabled>
          Select level
        </option>
        {eductationLevel?.map((item, index) => (
          <option key={index} value={item}>
            {item}
          </option>
        ))}
      </select>
      {errLevel && <p className="err_text">{errLevel}</p>}

      {isSchool && (
        <>
          <label>class / Grade</label>
          <select name="grade" value={grade} onChange={onChangeValue}>
            <option value="" disabled>
              Select Grade
            </option>
            {filteredGradeClass?.map((item, i) => (
              <option key={i} value={item}>
                {item}
              </option>
            ))}
          </select>
          {errGradeClass && <p className="err_text">{errGradeClass}</p>}

          <label>Board</label>
          <select name="board" value={board} onChange={onChangeValue}>
            <option value="" disabled>
              Select Board
            </option>
            {boards?.map((item, i) => (
              <option key={i} value={item}>
                {item}
              </option>
            ))}
          </select>
          {errBoard && <p className="err_text">{errBoard}</p>}

          <section className="tab_content">
            <label>Section</label>
            <input
              name="section"
              value={section}
              onChange={onChangeValue}
              placeholder="Enter Section"
            />
            {errSection && <p className="err_text">{errSection}</p>}
          </section>
        </>
      )}
    </section>
  );
};
